import React from 'react';

import PieChart from 'components/PieChart';
import { formatNumber } from 'util/strings';
import H2 from 'components/deprecated/legacyElements/H2';
import styles from './style.module.scss';

const numEmployeesParam = (numEmployees) => {
  const paramName = 'numEmployees';

  if (numEmployees <= 10) {
    return `${paramName}=1-10`;
  }
  if (numEmployees <= 25) {
    return `${paramName}=11-25`;
  }
  if (numEmployees <= 50) {
    return `${paramName}=26-50`;
  }
  if (numEmployees <= 100) {
    return `${paramName}=51-100`;
  }
  return `${paramName}=101+`;
};

export default ({
  blur,
  chartSlices,
  numEmployees,
  onHoverSlice,
  selectedCity,
  selectedSlice,
  totalSqft,
}) => (
  <div className={`${styles.spacePieChart} ${blur ? styles.blur : ''}`}>
    <H2>
      Recommended space:{' '}
      <span className="right">{formatNumber(totalSqft)} sqft</span>
    </H2>
    <PieChart
      className={styles.pie}
      slices={chartSlices}
      selectedSlice={selectedSlice}
      onHoverSlice={onHoverSlice}
    />
    <a
      href={`/office-space/ny/new-york?${numEmployeesParam(numEmployees)}`}
      className={`tsf-btn tsf-btn-secondary tsf-btn-xlarge ${styles.ctaButton}`}
    >
      View eligible spaces {selectedCity && `in ${selectedCity}`}
    </a>
    {totalSqft > 0 && (
      <ul className={styles.chartDescription}>
        {chartSlices.map((room, index) => (
          <li
            key={room.name}
            className={selectedSlice === index ? styles.sliceSelected : ''}
          >
            <div
              className={styles.sliceColor}
              style={{ borderColor: room.color }}
            />
            <span className={styles.sliceName}>
              {room.name}
              {room.count && ` (${room.count})`}
            </span>
            <p className={styles.slicePercent}>
              {formatNumber(room.value)} sqft
            </p>
          </li>
        ))}
      </ul>
    )}
  </div>
);
